import styled from 'styled-components';
import { CaptionRegularM } from '../../../../styles/globals';

export const LegendCont = styled.div`
  ${({ theme }) => `
    display: flex;
    width: 100%;
    margin: ${theme.layout};
    align-items: center;
    justify-content: flex-end;

    @media ${theme.layout.breakpoints.max.tablet} {
       justify-content: center;
    }
  `};
`;

export const ScoresCont = styled.div`
  ${({ theme }) => `
    display: flex;
    align-items: center;
    gap: 16px;

    @media ${theme.layout.breakpoints.max.tablet} {
      gap: 8px;
    }
  `};
`;

export const ScoreCont = styled.div`
  ${({ theme }) => `
    display: flex;
    align-items: center;
    gap: 8px;

    @media ${theme.layout.breakpoints.max.tablet} {
      gap: 4px;
    }
  `};
`;

interface IScoreBar {
  background: string;
}

export const ScoreBar = styled.span<IScoreBar>`
  ${({ background }) => `
    display: flex;
    width: 32px;
    height: 8px;
    align-items: center;
    justify-content: center;
    background: ${background};
    border-radius: 4px;
  `};
`;

export const ScoreText = styled(CaptionRegularM)`
  ${({ theme }) => `
    color: ${theme.colors.neutral.primary[80]};

    @media ${theme.layout.breakpoints.max.tablet} {
      font-size: 10px;
      line-height: 12px;
    }
  `};
`;
